import styles from "./callouts.module.css"

import React from "react"
import cx from "classnames"
import {Tooltip} from "shared/tooltips"
import * as fonts from "shared/fonts"

export const Detail = ({result, label, tooltipText, className = "stat", resultStyles, statStyles, labelStyles, dataTestId}) => {
  return (
    <div className={cx(styles[className], statStyles)} data-testid={dataTestId}>
      <div className={cx(styles["label"], labelStyles, tooltipText && styles["with-tooltip"], fonts.getFontClass())}>
        {label}
        {tooltipText && <Tooltip>{tooltipText}</Tooltip>}
      </div>
      <div className={cx(styles["result"], resultStyles, fonts.getFontClass())}>{result}</div>
      {className === "stat" && <div className={cx(styles["border-bottom"])} />}
    </div>
  )
}

export const DoubleStat = ({label, children}) => {
  return (
    <div className={styles["double-stat"]}>
      <div className={cx(styles["label"], styles["black"])}>{label}</div>
      <div className={styles["results"]}>{children}</div>
    </div>
  )
}

export const Callout = ({children, className = "callout", calloutStyles}) => (
  <div id="callout" className={cx(styles[className], calloutStyles, children && `count-${children.length}`)}>
    {children}
  </div>
)

export const EquationDetail = ({result, label, operand, ...props}) => (
  <div className={styles["eq-stat"]} {...props}>
    <div className={cx(styles["label"], fonts.getFontClass())}>{label}</div>
    <div className={cx(styles["result"], styles[operand], fonts.getFontClass())}>{result}</div>
  </div>
)

export const EquationOperand = ({operand}) => <div className={cx(styles["result"], fonts.getFontClass())}>{operand}</div>

export const EquationLine = () => <div className={cx(styles["equation-line"], fonts.getFontClass())}></div>

export const EquationCallout = ({children}) => <div className={styles["eq-callout"]}>{children}</div>
